const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const pad = (n) => String(n).padStart(2, "0");
const iso = (y, m, d) => `${y}-${pad(m)}-${pad(d)}`;
const endOf = (y, m) => iso(y, m, new Date(y, m, 0).getDate());

export const REG_OPTS = [["all", "All time"], ["tm", "This month"], ["lm", "Last month"], ["l3", "Last 3 months"], ["ty", "This year"], ["dates", "Between dates"], ["months", "Between months"]];
export const REG_DEFAULT = { k: "all", f: "", t: "", fm: "", tm: "" };

export const darDay = (s) => (s ? new Date(s).toLocaleDateString("en-CA", { timeZone: "Africa/Dar_es_Salaam" }) : null);
export const darToday = () => darDay(new Date().toISOString());
export const dMMM = (d) => (d ? `${Number(d.slice(8, 10))} ${MON[Number(d.slice(5, 7)) - 1]}` : "—");
export const dMMMy = (d) => (d ? `${dMMM(d)} ${d.slice(0, 4)}` : "—");
export const monYY = (m) => `${MON[Number(m.slice(5, 7)) - 1]} ${m.slice(2, 4)}`;

export function regRange(r) {
  const today = darToday();
  const Y = Number(today.slice(0, 4)), M = Number(today.slice(5, 7));
  const back = (n) => { const d = new Date(Y, M - 1 - n, 1); return [d.getFullYear(), d.getMonth() + 1]; };
  if (r.k === "tm") return { from: iso(Y, M, 1), to: today };
  if (r.k === "lm") { const [y, m] = back(1); return { from: iso(y, m, 1), to: endOf(y, m) }; }
  if (r.k === "l3") { const [y, m] = back(2); return { from: iso(y, m, 1), to: today }; }
  if (r.k === "ty") return { from: iso(Y, 1, 1), to: today };
  if (r.k === "dates") {
    let [f, t] = [r.f, r.t];
    if (f && t && f > t) [f, t] = [t, f];
    if (f) return { from: f, to: t || today };
    return t ? { from: null, to: t } : {};
  }
  if (r.k === "months") {
    let [f, t] = [r.fm, r.tm];
    if (f && t && f > t) [f, t] = [t, f];
    if (!f && !t) return {};
    const s = f || t;
    const e = t ? endOf(Number(t.slice(0, 4)), Number(t.slice(5, 7))) : today;
    return { from: `${s}-01`, to: e > today ? today : e };
  }
  return {};
}

export const isAll = (rg) => !rg.from && !rg.to;
export const inReg = (rg, day) => isAll(rg) || (!!day && (!rg.from || day >= rg.from) && (!rg.to || day <= rg.to));
export const rangeText = (rg) => (isAll(rg) ? "at any time" : rg.from ? `from ${dMMMy(rg.from)} to ${dMMMy(rg.to)}` : `up to ${dMMMy(rg.to)}`);
